import groupBy from 'lodash/groupBy';
import flatten from 'lodash/flatten';
import browserDetector from './browserDetector';
import store from '../store';

// @ playerData:  *Required - Player's user_uuid and round_uuid are min required
// @ playerData:  *Required - gameMode and handicap also required
// @ playerData:  *Optional - Gender - used for par and handicap values
// @ courseHoles: Optional - The array of course holes. 18 total

// const testShot1 = {
//   actionIndex: 10,
//   actionReason: 'shot',
//   actionType: 'shot',
//   aimHeading: 90.10144,
//   clientTime: '2021-10-19T20:14:15.342Z',
//   clubFaceAngle: 0,
//   clubHeadSpeed: 61.789253,
//   clubPathAngle: 0,
//   clubTypeKey: '1Wood',
//   courseHoleIndex: 3,
//   createdAt: '2021-10-19T20:14:32.346864Z',
//   detectedHoleIndex: 3,
//   endedInHole: false,
//   finalized: true,
//   id: 'd703db95-1c14-414b-924b-a243a424b332',
//   launchAngle: 12,
//   launchBackSpin: 1182.5,
//   launchBallSpeed: 91.4481,
//   launchDirection: 0,
//   launchSideSpin: 0,
//   mulligan: false,
//   roundID: '64222cf2-fd8a-4c45-9da7-fb7ebac1c2d2',
//   roundScore: 6,
//   roundScoreWithHandicap: 6,
//   roundSessionID: '5c2bf450-5291-4f49-92b9-e7d758719425',
//   score: 6,
//   segmentScore: 6,
//   segmentScoreIndex: 3,
//   shotIndex: 0,
//   snapshots: [
//     {
//       distance: 0,
//       height: 0.08000183,
//       milliseconds: 0,
//       pinDistance: 2657.717,
//       position: {
//         x: -187.43103,
//         y: 0.40341306,
//         z: 25.523832,
//       },
//       rollTime: 0,
//       speed: 91.4481,
//       spin: {
//         x: -0.03489001,
//         y: -19.708303,
//         z: 0,
//       },
//       terrainType: 'kTerrainFairway',
//       topViewPosition: {
//         x: 0.49992964,
//         y: 0.91664946,
//       },
//       type: 'launch',
//       windVelocity: {
//         x: 9.282877,
//         y: 9.282877,
//         z: 0,
//       },
//     },
//     {
//       distance: 58.543327,
//       height: 30.471945,
//       milliseconds: 683,
//       pinDistance: 2599.5093,
//       position: {
//         x: -129.22365,
//         y: 0.28324544,
//         z: 31.785404,
//       },
//       rollTime: 0,
//       speed: 81.288536,
//       spin: {
//         x: -0.033948954,
//         y: -19.176727,
//         z: 0,
//       },
//       terrainType: 'kTerrainBunker',
//       topViewPosition: {
//         x: 0.49994105,
//         y: 0.8983991,
//       },
//       type: 'apex',
//       windVelocity: {
//         x: 9.298863,
//         y: 9.298863,
//         z: 0,
//       },
//     },
//     {
//       distance: 150.5211,
//       height: 0.2837038,
//       milliseconds: 1899,
//       pinDistance: 2507.845,
//       position: {
//         x: -37.55956,
//         y: 0.04077261,
//         z: 11.559171,
//       },
//       rollTime: 0,
//       speed: 77.06973,
//       spin: {
//         x: -0.032335814,
//         y: -18.265507,
//         z: 0,
//       },
//       terrainType: 'kTerrainRough',
//       topViewPosition: {
//         x: 0.4999924,
//         y: 0.8696587,
//       },
//       type: 'total',
//       windVelocity: {
//         x: 8.838592,
//         y: 8.838592,
//         z: 0,
//       },
//     },
//   ],
//   startedOnTee: true,
//   totalDistance: 150.5211,
//   trackingSystemClubTypeKey: '',
//   trackingSystemKey: 'swing_gauge',
//   updatedAt: '2021-10-19T20:10:32.346864Z',
//   userID: '97a0ba45-acd0-46e3-aa1b-867790e83d1d',
//   // userID: '97a0ba45-acd0-46e3-aa1b-867790e83zzz',
// };
// const testShot2 = {
//   actionIndex: 9,
//   actionReason: 'shot',
//   actionType: 'shot',
//   aimHeading: 90.10144,
//   clientTime: '2021-10-19T20:14:15.342Z',
//   clubFaceAngle: 0,
//   clubHeadSpeed: 61.789253,
//   clubPathAngle: 0,
//   clubTypeKey: '1Wood',
//   courseHoleIndex: 3,
//   createdAt: '2021-10-19T20:14:32.346864Z',
//   detectedHoleIndex: 3,
//   endedInHole: false,
//   finalized: true,
//   id: 'd703db85-1c14-414b-924b-a243a424b312',
//   launchAngle: 12,
//   launchBackSpin: 1182.5,
//   launchBallSpeed: 91.4481,
//   launchDirection: 0,
//   launchSideSpin: 0,
//   mulligan: false,
//   roundID: '64222cf2-fd8a-4c45-9da7-fb7ebac1c2d2',
//   roundScore: 7,
//   roundScoreWithHandicap: 7,
//   roundSessionID: '5c2bf450-5291-4f49-92b9-e7d758719425',
//   score: 7,
//   segmentScore: 7,
//   segmentScoreIndex: 3,
//   shotIndex: 0,
//   snapshots: [
//     {
//       distance: 0,
//       height: 0.08000183,
//       milliseconds: 0,
//       pinDistance: 2657.717,
//       position: {
//         x: -187.43103,
//         y: 0.40341306,
//         z: 25.523832,
//       },
//       rollTime: 0,
//       speed: 91.4481,
//       spin: {
//         x: -0.03489001,
//         y: -19.708303,
//         z: 0,
//       },
//       terrainType: 'kTerrainFairway',
//       topViewPosition: {
//         x: 0.49992964,
//         y: 0.91664946,
//       },
//       type: 'launch',
//       windVelocity: {
//         x: 9.282877,
//         y: 9.282877,
//         z: 0,
//       },
//     },
//     {
//       distance: 58.543327,
//       height: 30.471945,
//       milliseconds: 683,
//       pinDistance: 2599.5093,
//       position: {
//         x: -129.22365,
//         y: 0.28324544,
//         z: 31.785404,
//       },
//       rollTime: 0,
//       speed: 81.288536,
//       spin: {
//         x: -0.033948954,
//         y: -19.176727,
//         z: 0,
//       },
//       terrainType: 'kTerrainBunker',
//       topViewPosition: {
//         x: 0.49994105,
//         y: 0.8983991,
//       },
//       type: 'apex',
//       windVelocity: {
//         x: 9.298863,
//         y: 9.298863,
//         z: 0,
//       },
//     },
//     {
//       distance: 150.5211,
//       height: 0.2837038,
//       milliseconds: 1899,
//       pinDistance: 2507.845,
//       position: {
//         x: -37.55956,
//         y: 0.04077261,
//         z: 11.559171,
//       },
//       rollTime: 0,
//       speed: 77.06973,
//       spin: {
//         x: -0.032335814,
//         y: -18.265507,
//         z: 0,
//       },
//       terrainType: 'kTerrainRough',
//       topViewPosition: {
//         x: 0.4999924,
//         y: 0.8696587,
//       },
//       type: 'total',
//       windVelocity: {
//         x: 8.838592,
//         y: 8.838592,
//         z: 0,
//       },
//     },
//   ],
//   startedOnTee: true,
//   totalDistance: 150.5211,
//   trackingSystemClubTypeKey: '',
//   trackingSystemKey: 'swing_gauge',
//   updatedAt: '2021-10-19T20:10:32.346864Z',
//   userID: '8929c9e4-7249-4c4b-8ddb-1a8d6311448d',
//   // userID: 'zzz9c9e4-7249-4c4b-8ddb-1a8d6311448d',
// };

const round = (v) => {
  return (v >= 0 || -1) * Math.round(Math.abs(v));
  // return (v >= 0 || -1) * Math.ceil(Math.abs(v));
};

const getPlayerInitials = (data) => {
  if (!data?.name) return '';
  return data.name
    .split(' ')
    .map((i) => {
      return i.charAt(0).toUpperCase();
    })
    .join('');
};

const checkTerrain = (check, terrain) => {
  return check && check?.terrainType === terrain;
};

const handicapScoresCalc = (handicap, holeHandicaps, scores) => {
  // handicap = -18;
  // handicap = Math.round(handicap);
  handicap = round(handicap);

  if (handicap < -9) {
    handicap = -9;
  }

  let netScores = [];
  const stablefordTotals = [];
  let reduction = 0;
  const holeTotal = 18;
  // const roundOne = handicap / holeTotal <= 1; // 0-18 - minus 1
  const roundTwo = handicap / holeTotal > 1 && handicap / holeTotal <= 2; // 19-36 - minus 2
  const hcpTwo = handicap - holeTotal;
  const roundThree = handicap / holeTotal > 2; // 36-54 - minus 3
  const hcpThree = handicap - holeTotal * 2;

  //* Handicap 18 or less, take one stroke off each hole
  netScores = scores.map((score, i) => {
    // console.log('i:', i, `Hole: ${i + 1}`);
    if (handicap >= holeHandicaps[i] && score !== null) {
      // console.log('score:', score);
      // console.log('roundOne:', roundOne);
      // console.log('roundTwo:', roundTwo);
      // console.log('hcpTwo:', hcpTwo);
      // console.log('roundThree:', roundThree);
      // console.log('hcpThree:', hcpThree);

      // console.log('round one subtract 1 - 1 less');
      //* round one so subtract 1 if there's any handicap - 1 total less
      //* reduction increased one if there's any handicap - max of two
      score -= 1;
      reduction += 1;
      if ((roundTwo || roundThree) && hcpTwo >= holeHandicaps[i]) {
        //* round two so subtract 1 more - 2 total less
        //* reduction increased one more if applicable - max of two
        // console.log('round two subtract 1 more - 2 less');
        score -= 1;
        reduction += 1;
      }
      if ((roundThree || roundTwo) && hcpThree >= holeHandicaps[i]) {
        //* round three so subtract 1 more - 3 total less
        //* reduction not increased here as it's capped at a max of two
        // console.log('round three subtract 1 more - 3 less');
        score -= 1;
        // reduction += 1;
      }
    }

    if (handicap < 0 && score !== null) {
      const adjusted = holeHandicaps[i] - 18;
      const dontAdjust = handicap >= adjusted;

      if (!dontAdjust) {
        score += 1;
      }
    }

    // console.log('score2:', score);
    // console.log('reduction:', reduction);
    stablefordTotals.push(reduction);
    reduction = 0;
    return score < 1 && score !== null ? 1 : score;
  });
  // console.log('netScores1:', netScores);
  // console.log('stablefordTotals:', stablefordTotals);

  // return netScores;
  // console.log('netScores:', netScores);
  return { netScores, stablefordTotals };
};

const stablefordPointCalc = (holeStableFordTotals, holePars, holeNetScores) => {
  let stbPoints = [];

  stbPoints = holeNetScores.map((score, i) => {
    let points = 0;
    // console.log('i:', i, `Hole: ${i + 1}`);

    if (score !== null) {
      // score -= holePars[i] + holeStableFordTotals[i];
      score -= holePars[i];

      switch (score) {
        case -9:
        case -8:
        case -7:
        case -6:
        case -5:
        case -4:
        case -3:
        case -2:
          points = 4;
          break;
        case -1:
          points = 3;
          break;
        case 0:
          points = 2;
          break;
        case 1:
          points = 1;
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          points = 0;
          break;
        default:
          points = 0;
          break;
      }
    }
    // console.log('points:', points);
    return score === null ? null : points;
  });

  // console.log('stbPoints:', stbPoints);
  return stbPoints;
};

const getHoleGroups = (shotArray) => {
  return Object.values(
    shotArray.reduce((acc, curVal, i, arr) => {
      if (!curVal) {
        return acc;
      }
      //* Check if it is an action record and insert correct courseHoleIndex
      if (!curVal?.courseHoleIndex) {
        for (const item in arr) {
          if ({}.hasOwnProperty.call(arr, item)) {
            if (curVal?.segmentScoreIndex === arr[item]?.segmentScoreIndex) {
              curVal.courseHoleIndex = arr[item].courseHoleIndex;
            }
            //* Added in to handle next hole actions and incorrect hole index - double-check this ❌
            // if (curVal?.actionReason === 'next hole' || curVal?.actionReason === 'pickup') {
            //   curVal.courseHoleIndex = arr[item].courseHoleIndex + 1;
            // }
          }
        }
      }

      // TODO
      // acc[curVal?.segmentScoreIndex] = [...(acc[curVal?.segmentScoreIndex] || []), curVal];
      //* Original setup. Issues show up when using courseHoleIndex
      acc[curVal?.courseHoleIndex ? curVal?.courseHoleIndex : curVal?.segmentScoreIndex] = [
        ...(acc[curVal?.courseHoleIndex ? curVal?.courseHoleIndex : curVal?.segmentScoreIndex] ||
          []),
        curVal,
      ];
      return acc;
    }, {})
  );
};

const getBestBallScores = (holeGroup, roundHoles) => {
  // console.log('holeGroup:', holeGroup);
  let score = 0;
  const holeScores = [];

  for (const hole in holeGroup) {
    if (hole) {
      roundHoles?.forEach((x, index) => {
        if (index.toString() === hole.toString()) {
          holeGroup[hole].hole = x;
        }
      });
      holeGroup[hole]?.forEach((item, i) => {
        if (item.courseHoleIndex === undefined) {
          item.courseHoleIndex = holeGroup[hole].hole;
        }
        item.holeNumber = holeGroup[hole].hole;
      });
    }
  }

  for (let x = 0; x < 18; x++) {
    //* This runs through scoring for current user being viewed
    holeGroup?.forEach((holes = [], i) => {
      //* Limit sorting through holes played only if they are the current hole
      const { courseHoleIndex, segmentScoreIndex } = holes[0] || {};

      if (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) {
        holes?.forEach((holeDetails = {}, i) => {
          const { courseHoleIndex, segmentScore, mulligan } = holeDetails;

          if ((courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) && !mulligan) {
            //* Get hole score
            score = segmentScore > score ? segmentScore : score;
          }

          holeScores[x] = score !== 0 ? score : null;
        });
      }
    });

    if (holeScores[x] === undefined) {
      holeScores[x] = null;
    }

    score = 0;
  } //* end 18 hole for loop
  return holeScores;
};

const getScrambleScores = (holeGroup) => {
  let score = 0;
  const holeScores = [];

  for (let x = 0; x < 18; x++) {
    //* This runs through scoring for current user being viewed
    holeGroup?.forEach((holes = [], i) => {
      //* Limit sorting through holes played only if they are the current hole
      const { courseHoleIndex, segmentScoreIndex } = holes[0] || {};
      // console.log('courseHoleIndex:', courseHoleIndex);

      if (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) {
        holes?.forEach((holeDetails = {}, i) => {
          const { courseHoleIndex, segmentScore, mulligan, endedInHole, actionType, actionReason } =
            holeDetails;
          // TODO Does ended in hole matter for actions?

          //* if action is a score_adjustment, ignore it
          if (actionReason === 'score_adjustment') {
            return;
          }

          if (
            (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) &&
            !mulligan &&
            // (endedInHole || actionType === 'score')
            endedInHole
          ) {
            //* Get hole score
            score = segmentScore > score ? segmentScore : score;
          } else if (
            (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) &&
            !mulligan &&
            (actionReason === 'next hole' || actionReason === 'pickup')
          ) {
            //* Get hole score still if actionReason is next hole or pickup
            score = segmentScore > score ? segmentScore : score;
          } else {
            score = segmentScore > score ? segmentScore : score;
          }

          holeScores[x] = score !== 0 ? score : null;
        });
      }
    });

    if (holeScores[x] === undefined) {
      holeScores[x] = null;
    }

    score = 0;
  } //* end 18 hole for loop
  return holeScores;
};

const groupByMulti = (arr, key1, key2) => {
  const initialValue = {};
  return arr.reduce((acc, cval) => {
    const myAttribute = cval[key1] ? cval[key1] : cval[key2];
    acc[myAttribute] = [...(acc[myAttribute] || []), cval];
    return acc;
  }, initialValue);
};

const scorecardDataConfig = async (playerData = {}, courseHoles = [], roundHoles = []) => {
  // console.log('courseHoles:', courseHoles);
  // console.log('roundHoles:', roundHoles);
  // console.log('playerData:', playerData);
  const {
    gender: playerGender,
    gameMode = 'stroke_play',
    handicap,
    clubHandicap,
    players = [],
    guestPlayers = [],
  } = playerData;
  // console.log('gameMode:', gameMode);
  // console.log('handicap:', handicap);
  // console.log('clubHandicap:', clubHandicap);
  // console.log('players:', players);
  // console.log('guestPlayers:', guestPlayers);

  const allPlayers = [...players, ...guestPlayers].map((player) => {
    return { team: player.team, id: player.id, name: player?.name };
  });

  const currentPlayer = players?.find((player) => {
    return player?.id === playerData?.user_uuid;
  });

  const currentTeam = players?.filter((player) => {
    return player?.team === currentPlayer?.team;
  });

  const holePars = courseHoles.map((hole) => {
    switch (playerGender) {
      case 'male':
        return hole?.mens_par ?? hole?.mensPar;
      case 'female':
        return hole?.ladies_par ?? hole?.ladiesPar;
      default:
        return hole?.mens_par ?? hole?.mensPar;
    }
  });
  const holeHandicaps = courseHoles.map((hole) => {
    switch (playerGender) {
      case 'male':
        return hole?.mens_handicap ?? hole?.mensHandicap;
      case 'female':
        return hole?.ladies_handicap ?? hole?.ladiesHandicap;
      default:
        return hole?.mens_handicap ?? hole?.mensHandicap;
    }
  });

  // @ Test setup to get holes selected to play and populate null values for remaining =======
  let holesPlayed = [];
  holesPlayed = roundHoles;
  for (let i = 0; i < 18; i++) {
    if (holesPlayed[i] === undefined) {
      holesPlayed[i] = null;
    }
  }
  // console.log('holesPlayed:', holesPlayed);

  let handicapUsed = 0;
  let shotData = {};
  let holeScores = [];
  let holeNetScores = [];
  let holeStableFordTotals = [];
  let stablefordScores = [];
  let bestBallTeamScores = [];
  let scrambleTeamScores = [];
  let scoreCalc = {};
  const holeRoundScores = [];
  const teeClubs = [];
  const fairwayShots = [];
  const sandShots = [];
  const greensInRegulation = [];
  const mulligans = [];
  const penalties = [];
  const puttingShots = [];
  let score = 0;
  // @ Test data setup - remove
  // const bbScore = 0;
  // const bbStuff = [];
  // @ ==
  const netScore = 0;
  let holeRoundScore = null;
  let teeClub = '';
  let fairway = false;
  let sand = false;
  let gir = false;
  let mulliganShot = 0;
  let penalty = 0;
  let putts = 0;
  const netGameModes = [
    'stroke_play',
    'StrokePlay',
    'best_ball',
    'BestBall',
    'stableford',
    'Stableford',
  ];
  const stablefordGameModes = ['stableford', 'Stableford'];
  // const stablefordGameModes = ['stableford', 'Stableford', 'stroke_play', 'StrokePlay']; // @ testing

  let cacheBust;
  const browser = browserDetector();
  browser === 'IE 11' ? (cacheBust = `/?cb=${Date.now()}`) : (cacheBust = '');

  //! Use if not merging actions in the store
  // const actionRecords = await store.dispatch('shots/actions', `${playerData.round_uuid}`);

  const payload = {
    roundID: `${playerData.round_uuid}${cacheBust}`,
    userID: playerData.user_uuid,
    bestBall: gameMode?.toLowerCase()?.replace('_', '') === 'bestball',
    scramble: gameMode?.toLowerCase() === 'scramble',
  };

  await store.dispatch('shots/all', payload).then((res) => {
    let shots = [];
    shots = store.getters['shots/shotList'] ?? [];

    // @ Testing additional shots - remove
    // shots = [...shots, testShot1, testShot2];
    // console.log('shots2:', shots);

    //* Filter shots by user. Not filtering out mulligan shots.
    const filteredShotList = shots?.filter(
      // shot => !shot.mulligan && shot.userID === playerData.user_uuid
      (shot) => {
        return shot.userID === playerData.user_uuid;
      }
    );

    // ? Needed anymore?
    //* Return all shots for all users except guests for best ball. Not filtering out mulligan shots.
    const bestBallFilteredShotList = shots?.filter((shot) => {
      if (
        gameMode?.toLowerCase()?.replace('_', '') === 'bestball' ||
        gameMode?.toLowerCase() === 'scramble'
      ) {
        const teamShot = currentTeam.some((player) => {
          return player.id === shot.userID;
        });
        return shot?.userID && teamShot;
      }
      return shot.userID === playerData.user_uuid;
    });
    // console.log('bestBallFilteredShotList:', bestBallFilteredShotList);

    //! Use if not merging actions in the store
    // filteredShotList = actionRecords
    // ? filteredShotList.concat(actionRecords?.map((action) => action))
    // : filteredShotList;
    // console.log('filteredShotList:', filteredShotList);

    if (filteredShotList?.length > 0 || bestBallFilteredShotList?.length > 0) {
      //* Moved below to enable course hole to be set
      // const holeGroups = getHoleGroups(filteredShotList);
      // console.log('holeGroups:', holeGroups);

      const newHoleGroups = groupBy(filteredShotList, 'segmentScoreIndex');
      // console.log('newHoleGroups:', newHoleGroups);

      for (const hole in newHoleGroups) {
        if (hole) {
          roundHoles?.forEach((x, index) => {
            if (index.toString() === hole.toString()) {
              newHoleGroups[hole].hole = x;
            }
          });

          // console.log('newHoleGroups after:', newHoleGroups);

          newHoleGroups[hole]?.forEach((item, i) => {
            if (item.courseHoleIndex === undefined) {
              item.courseHoleIndex = newHoleGroups[hole].hole;
            }
            item.holeNumber = newHoleGroups[hole].hole;

            // @ start testing new scorecard setup ===========================================

            // console.log(newHoleGroups[hole].hole);
            // console.log('item:', item);
            // const {
            //   courseHoleIndex,
            //   segmentScore,
            //   startedOnTee,
            //   clubTypeKey,
            //   snapshots,
            //   mulligan,
            //   penaltyShot,
            // } = item;
            // console.log('courseHoleIndex:', courseHoleIndex);
            // console.log('segmentScore:', segmentScore);
            // console.log('startedOnTee:', startedOnTee);
            // console.log('clubTypeKey:', clubTypeKey);
            // console.log('snapshots:', snapshots);
            // console.log('mulligan:', mulligan);
            // console.log('penaltyShot:', penaltyShot);

            // holesPlayed = [...holesPlayed, newHoleGroups[hole].hole];

            // if (!mulligan) {
            //   const firstShot = holes?.[0];
            //   const secondShot = holes?.[1];
            //   const thirdShot = holes?.[2];
            //   // const par = score === holePars[x];
            //   //* get correct snapshot total record
            //   const firstShotSnapTotal = firstShot?.snapshots?.find((snap) => {
            //     return (snap.type = 'total');
            //   });
            //   const secondShotSnapTotal = secondShot?.snapshots?.find((snap) => {
            //     return (snap.type = 'total');
            //   });
            //   const thirdShotSnapTotal = thirdShot?.snapshots?.find((snap) => {
            //     return (snap.type = 'total');
            //   });
            //   //* Get hole score
            //   score = segmentScore > score ? segmentScore : score;
            //   // console.log('score:', score);
            //   //* Calculate Hole Round Score
            //   (courseHoleIndex
            //   ? courseHoleIndex === x
            //   : segmentScoreIndex === x)
            //     ? (holeRoundScore = score - holePars[x])
            //     : null;
            //   //* Get tee club
            //   startedOnTee ? (teeClub = clubTypeKey) : null;
            //   //* Calculate fairway shot
            //   startedOnTee && checkTerrain(firstShotSnapTotal, 'kTerrainFairway')
            //     ? (fairway = true)
            //     : null;
            //   //* Calculate sand save
            //   snapshots?.forEach((snap) => {
            //     return (snap.type === 'launch' || snap.type === 'total') &&
            //       checkTerrain(snap, 'kTerrainBunker')
            //       ? (sand = true)
            //       : null;
            //   });
            //   //* Calculate GIR
            //   switch (holePars[x]) {
            //     case 3:
            //       gir = checkTerrain(firstShotSnapTotal, 'kTerrainGreen');
            //       break;
            //     case 4:
            //       gir =
            //         firstShot && firstShotSnapTotal
            //           ? checkTerrain(firstShotSnapTotal, 'kTerrainGreen')
            //           : false;
            //       gir =
            //         !gir && secondShot && secondShotSnapTotal
            //           ? checkTerrain(secondShotSnapTotal, 'kTerrainGreen')
            //           : gir || false;
            //       break;
            //     case 5:
            //       gir =
            //         firstShot && firstShotSnapTotal
            //           ? checkTerrain(firstShotSnapTotal, 'kTerrainGreen')
            //           : false;
            //       gir =
            //         !gir && secondShot && secondShotSnapTotal
            //           ? checkTerrain(secondShotSnapTotal, 'kTerrainGreen')
            //           : gir || false;
            //       gir =
            //         !gir && thirdShot && thirdShotSnapTotal
            //           ? checkTerrain(thirdShotSnapTotal, 'kTerrainGreen')
            //           : gir || false;
            //       break;
            //     default:
            //       gir = false;
            //       break;
            //   }
            //   //* Get total putts. This only gets actual putts and not gimmes
            //   clubTypeKey === 'Putter' && !mulligan ? putts++ : null;
            // }

            // //* Calculate Mulligans
            // courseHoleIndex === x && mulligan ? mulliganShot++ : 0;

            // //* Calculate Penalty Shots
            // courseHoleIndex === x && penaltyShot ? penalty++ : 0;

            // holeScores[x] = score !== 0 ? score : null;
            // teeClubs[x] = teeClub ? teeClub.slice(0, 2) : null;
            // fairwayShots[x] = fairway || false;
            // sandShots[x] = sand || false;
            // greensInRegulation[x] = gir || false;
            // mulligans[x] = mulliganShot !== 0 ? mulliganShot : null;
            // penalties[x] = penalty !== 0 ? penalty : null;
            // puttingShots[x] = putts || null;
            // holeRoundScores[x] = holeRoundScore !== null ? holeRoundScore : null;
            // holeNetScores[x] = score !== 0 && netGameModes.includes(gameMode) ? score : '-';

            // //* Test for scramble
            // // holeNetScores[x] = '-';

            // @ end testing new scorecard setup ===========================================
          });
        }
      }

      //* original calc ⬇️ ===================================================================

      const holeGroups = getHoleGroups(filteredShotList);
      // console.log('holeGroups:', holeGroups);

      // ? Needed anymore?
      // const bestBallHoleGroups = getHoleGroups(bestBallFilteredShotList);
      // console.log('bestBallHoleGroups:', bestBallHoleGroups);

      for (let x = 0; x < 18; x++) {
        //* This runs through scoring for current user being viewed
        holeGroups?.forEach((holes = [], j) => {
          // console.log('holes:', holes);
          //* Limit sorting through holes played only if they are the current hole
          const { courseHoleIndex, segmentScoreIndex } = holes[0] || {};

          // TODO
          // if (segmentScoreIndex === x) {
          //* Original setup. Issues show up when using courseHoleIndex
          if (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) {
            const filteredHoles = holes?.filter((hole) => {
              return !hole.mulligan;
            });
            filteredHoles.forEach((holeInfo = {}, h) => {
              const {
                courseHoleIndex,
                segmentScore,
                startedOnTee,
                clubTypeKey,
                snapshots,
                mulligan,
                penaltyShot,
              } = holeInfo;

              const shotCheck = holeInfo ?? null;

              const shotSnapTotal = shotCheck?.snapshots?.find((snap) => {
                return snap.type === 'total';
              });

              //* Get hole score
              score = segmentScore > score ? segmentScore : score;
              // console.log('score:', score);

              //* Calculate Hole Round Score
              // TODO
              // segmentScoreIndex === x ? (holeRoundScore = score - holePars[x]) : null;
              //* Original setup. Issues show up when using courseHoleIndex
              (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x)
                ? (holeRoundScore = score - holePars[x])
                : null;

              //* Get tee club
              startedOnTee ? (teeClub = clubTypeKey) : null;

              //* Calculate fairway shot
              startedOnTee && checkTerrain(shotSnapTotal, 'kTerrainFairway')
                ? (fairway = true)
                : null;

              //* Calculate sand save
              snapshots?.forEach((snap) => {
                return (snap.type === 'launch' || snap.type === 'total') &&
                  checkTerrain(snap, 'kTerrainBunker')
                  ? (sand = true)
                  : null;
              });

              //* Calculate GIR
              switch (holePars[x]) {
                case 3:
                  if (
                    (h === 0 && shotCheck && shotSnapTotal) ||
                    (h === 1 && shotCheck && shotSnapTotal && shotCheck.penaltyShot === 'rehit')
                  ) {
                    gir = checkTerrain(shotSnapTotal, 'kTerrainGreen');
                  }
                  break;
                case 4:
                  if (
                    (!gir && h <= 1 && shotCheck && shotSnapTotal) ||
                    (!gir &&
                      h <= 2 &&
                      shotCheck &&
                      shotSnapTotal &&
                      shotCheck.penaltyShot === 'rehit')
                  ) {
                    gir = checkTerrain(shotSnapTotal, 'kTerrainGreen');
                  }
                  break;
                case 5:
                  if (
                    (!gir && h <= 2 && shotCheck && shotSnapTotal) ||
                    (!gir &&
                      h <= 3 &&
                      shotCheck &&
                      shotSnapTotal &&
                      shotCheck.penaltyShot === 'rehit')
                  ) {
                    gir = checkTerrain(shotSnapTotal, 'kTerrainGreen');
                  }
                  break;
                default:
                  gir = false;
                  break;
              }

              //* Get total putts. This only gets actual putts and not gimmes
              clubTypeKey === 'Putter' && !mulligan ? putts++ : null;

              teeClubs[x] = teeClub ? teeClub.slice(0, 2) : null;
              fairwayShots[x] = fairway || false;
              sandShots[x] = sand || false;
              greensInRegulation[x] = gir || false;
              puttingShots[x] = putts || null;
            });

            holes?.forEach((holeDetails = {}, i) => {
              const {
                courseHoleIndex,
                // segmentScore,
                // startedOnTee,
                // clubTypeKey,
                // snapshots,
                mulligan,
                penaltyShot,
              } = holeDetails;

              // TODO
              // if (segmentScoreIndex === x && !mulligan) {
              //* Original setup. Issues show up when using courseHoleIndex
              // * original setup. Issues with mulligan shots
              // * moved to separate iteration above to calculate stats
              // if (
              //   (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x) &&
              //   !mulligan
              // ) {
              //   const firstShot = holes?.[0];
              //   const secondShot = holes?.[1];
              //   const thirdShot = holes?.[2];

              //   //* get correct snapshot total record
              //   const firstShotSnapTotal = firstShot?.snapshots?.find((snap) => {
              //     return snap.type === 'total';
              //   });
              //   const secondShotSnapTotal = secondShot?.snapshots?.find((snap) => {
              //     return snap.type === 'total';
              //   });
              //   const thirdShotSnapTotal = thirdShot?.snapshots?.find((snap) => {
              //     return snap.type === 'total';
              //   });

              //   //* Get hole score
              //   score = segmentScore > score ? segmentScore : score;
              //   // console.log('score:', score);

              //   //* Calculate Hole Round Score
              //   // TODO
              //   // segmentScoreIndex === x ? (holeRoundScore = score - holePars[x]) : null;
              //   //* Original setup. Issues show up when using courseHoleIndex
              //   (courseHoleIndex ? courseHoleIndex === x : segmentScoreIndex === x)
              //     ? (holeRoundScore = score - holePars[x])
              //     : null;

              //   //* Get tee club
              //   startedOnTee ? (teeClub = clubTypeKey) : null;

              //   //* Calculate fairway shot
              //   startedOnTee && checkTerrain(firstShotSnapTotal, 'kTerrainFairway')
              //     ? (fairway = true)
              //     : null;

              //   //* Calculate sand save
              //   snapshots?.forEach((snap) => {
              //     return (snap.type === 'launch' || snap.type === 'total') &&
              //       checkTerrain(snap, 'kTerrainBunker')
              //       ? (sand = true)
              //       : null;
              //   });

              //   //* Calculate GIR
              //   switch (holePars[x]) {
              //     case 3:
              //       gir = checkTerrain(firstShotSnapTotal, 'kTerrainGreen');
              //       break;
              //     case 4:
              //       gir =
              //         firstShot && firstShotSnapTotal
              //           ? checkTerrain(firstShotSnapTotal, 'kTerrainGreen')
              //           : false;
              //       gir =
              //         !gir && secondShot && secondShotSnapTotal
              //           ? checkTerrain(secondShotSnapTotal, 'kTerrainGreen')
              //           : gir || false;
              //       break;
              //     case 5:
              //       gir =
              //         firstShot && firstShotSnapTotal
              //           ? checkTerrain(firstShotSnapTotal, 'kTerrainGreen')
              //           : false;
              //       gir =
              //         !gir && secondShot && secondShotSnapTotal
              //           ? checkTerrain(secondShotSnapTotal, 'kTerrainGreen')
              //           : gir || false;
              //       gir =
              //         !gir && thirdShot && thirdShotSnapTotal
              //           ? checkTerrain(thirdShotSnapTotal, 'kTerrainGreen')
              //           : gir || false;
              //       break;
              //     default:
              //       gir = false;
              //       break;
              //   }

              //   //* Get total putts. This only gets actual putts and not gimmes
              //   clubTypeKey === 'Putter' && !mulligan ? putts++ : null;
              // }

              //* Calculate Mulligans
              //* Original setup. Issues show up when using courseHoleIndex
              courseHoleIndex === x && mulligan ? mulliganShot++ : 0;
              // TODO
              // segmentScoreIndex === x && mulligan ? mulliganShot++ : 0;

              //* Calculate Penalty Shots
              //* Original setup. Issues show up when using courseHoleIndex
              courseHoleIndex === x && penaltyShot ? penalty++ : 0;
              // TODO
              // segmentScoreIndex === x && penaltyShot ? penalty++ : 0;

              holeScores[x] = score !== 0 ? score : null;
              // teeClubs[x] = teeClub ? teeClub.slice(0, 2) : null;
              // fairwayShots[x] = fairway || false;
              // sandShots[x] = sand || false;
              // greensInRegulation[x] = gir || false;
              mulligans[x] = mulliganShot !== 0 ? mulliganShot : null;
              penalties[x] = penalty !== 0 ? penalty : null;
              // puttingShots[x] = putts || null;
              holeRoundScores[x] = holeRoundScore !== null ? holeRoundScore : null;
              holeNetScores[x] = score !== 0 && netGameModes.includes(gameMode) ? score : '-';

              //* Test for scramble
              // holeNetScores[x] = '-';
            });
          }
        });

        holeScores[x] <= holePars[x] && sandShots[x]
          ? (sandShots[x] = true)
          : (sandShots[x] = false);

        //* If no value in holeScore, set it to null to display correctly in scorecard
        if (holeScores[x] === undefined) {
          holeScores[x] = null;
        }
        if (holeRoundScores[x] === undefined) {
          holeRoundScores[x] = null;
        }
        if (holeNetScores[x] === undefined) {
          holeNetScores[x] = null;
        }

        score = 0;
        holeRoundScore = null;
        teeClub = null;
        fairway = false;
        sand = false;
        gir = false;
        mulliganShot = 0;
        penalty = 0;
        putts = 0;
      } //* end 18 hole for loop

      // @ ============================================================================
      //* Start of scramble  score calc
      if (gameMode.toLowerCase() === 'scramble') {
        const teamData = {};
        let groupedScoreData = [];

        //* Group users and shot data
        const teamGroups = groupBy(allPlayers, 'team');
        const groupAllShotsByID = groupByMulti(shots, 'userID', 'guestID');

        for (const team in teamGroups) {
          if (team) {
            // console.log('teamGroups:', teamGroups[team]);
            const teamGroupedShots = teamGroups[team].map((player) => {
              return groupAllShotsByID[player.id];
            });
            // teamData[team] = teamGroupedShots;

            //* Disabling - causes problems when polling data but no problems without
            //* Leaving to double-check
            // for (const hole in teamGroupedShots) {
            //   if (hole) {
            //     roundHoles.forEach((x, index) => {
            //       if (index.toString() === hole.toString()) {
            //         if (!teamGroupedShots[hole]) return;
            //         teamGroupedShots[hole].hole = x;
            //       }
            //     });
            //     if (!teamGroupedShots[hole]) return;
            //     teamGroupedShots[hole].forEach((item, i) => {
            //       if (item.courseHoleIndex === undefined) {
            //         item.courseHoleIndex = teamGroupedShots[hole].hole;
            //       }
            //       item.holeNumber = teamGroupedShots[hole].hole;
            //     });
            //   }
            // }

            // console.log('team:', teamGroups[team]);
            //* get first characters of player names for each team
            // const teamPlayers = teamGroups[team]
            //   .map((data) => {
            //     const firstChars = getPlayerInitials(data);
            //     return firstChars;
            //   })
            //   .join(', ');

            teamData[team] = getHoleGroups(flatten(teamGroupedShots));

            const data = getScrambleScores(teamData[team]);
            groupedScoreData = [...groupedScoreData, { team, scores: data }];

            //* use with teamPlayer initials setup
            // groupedScoreData = [...groupedScoreData, { team, scores: data, teamPlayers }];
          }
        }
        // console.log('teamData:', teamData);
        // console.log('groupedScoreData:', groupedScoreData);
        scrambleTeamScores = [...groupedScoreData];

        // @ Test data - remove
        // scrambleTeamScores = [...groupedScoreData, ...groupedScoreData];
      }

      // @ ============================================================================
      //* Start of best ball team score calc
      if (gameMode?.toLowerCase()?.replace('_', '') === 'bestball') {
        //* Group users and shot data
        const groupUserShotsByID = groupBy(bestBallFilteredShotList, 'userID');
        const playerIDs = Object.keys(groupUserShotsByID);
        const playerHoleGroups = playerIDs.map((player) => {
          return getHoleGroups(groupUserShotsByID[player]);
        });

        let scoresOne = [];
        const bScores = [];
        let setScores = [];
        scoresOne = playerHoleGroups.map((group, j) => {
          const data = getBestBallScores(group, roundHoles);
          // @ Test data - remove
          // data[1] = Math.round(Math.random() * 6);
          // data[2] = Math.round(Math.random() * 6);
          return data;
        });

        scoresOne?.forEach((scoreData, i) => {
          scoreData?.forEach((score, j) => {
            const curVal = score;

            // if (curVal !== null && curVal < setScores[j]) {
            if (curVal !== null && curVal < setScores[j] && setScores?.[j]) {
              bScores[j] = curVal;
              // } else if (curVal !== null && curVal > setScores[j]) {
            } else if (curVal !== null && curVal > setScores[j] && setScores?.[j]) {
              bScores[j] = setScores[j];
            } else {
              // bScores[j] = curVal || null;
              bScores[j] = curVal || setScores?.[j];
            }

            if (bScores[j] === undefined) {
              bScores[j] = null;
            }
            setScores = [...bScores];
          });
        });
        bestBallTeamScores = [...bScores];
      }
    } else {
      holeScores = new Array(18).fill(null);
    }

    if (netGameModes.includes(gameMode) || stablefordGameModes.includes(gameMode)) {
      handicapUsed = !clubHandicap ? handicap : clubHandicap;
      scoreCalc = handicapScoresCalc(handicapUsed, holeHandicaps, holeScores);
    }

    if (netGameModes.includes(gameMode)) {
      holeNetScores = scoreCalc.netScores;
    }
    if (stablefordGameModes.includes(gameMode)) {
      holeStableFordTotals = scoreCalc.stablefordTotals;
      stablefordScores = stablefordPointCalc(holeStableFordTotals, holePars, holeNetScores);
    }

    // TODO Get the hole distance. Not sure if we want to display all tee distances or just a single distance
    shotData = {
      ...shotData,
      holeHandicaps,
      holePars,
      holeScores,
      holeRoundScores,
      holeNetScores,
      holeStableFordTotals,
      stablefordScores,
      bestBallTeamScores,
      scrambleTeamScores,
      teeClubs,
      fairwayShots,
      sandShots,
      greensInRegulation,
      mulligans,
      penalties,
      puttingShots,
      handicap: handicapUsed,
    };
  });

  const matchReport = shotData.holeScores
    .map((item, i) => {
      return {
        roundScore: shotData.holeRoundScores[i],
        score: shotData.holeScores[i],
        scoreWithHandicap: shotData.holeNetScores[i],
        strokePlayData: {
          teeShotOnFairway: shotData.fairwayShots[i],
          sandSave: shotData.sandShots[i],
          gir: shotData.greensInRegulation[i],
          putts: shotData.puttingShots[i] ?? 0,
          mulligans: shotData.mulligans[i] ?? 0,
          penalties: shotData.penalties[i] ?? 0,
        },
        clubType: shotData.teeClubs[i],
        segmentPar: shotData.holePars[i],
        segmentHandicap: shotData.holeHandicaps[i],
        courseHoleIndex: i,
        courseHole: i + 1,
      };
    })
    .filter((data) => {
      return data.score !== null;
    });
  const scrambleTeamMatchReport = shotData.scrambleTeamScores.map((item, i) => {
    return {
      index: item.team,
      segments: item.scores
        .map((score, x) => {
          return {
            score,
            courseHoleIndex: x,
            courseHole: x + 1,
          };
        })
        .filter((data) => {
          return data.score !== null;
        }),
    };
  });
  const bbTeamMatchReport = shotData.bestBallTeamScores
    .map((item, i) => {
      return {
        score: item,
        courseHoleIndex: i,
        courseHole: i + 1,
      };
    })
    .filter((data) => {
      return data.score !== null;
    });
  // console.log('V2 shotData:', shotData);
  // console.log('matchReport:', matchReport);
  // console.log('scrambleTeamMatchReport:', scrambleTeamMatchReport);
  // console.log('bbTeamMatchReport:', bbTeamMatchReport);

  return shotData;
};

export { scorecardDataConfig as default };
